module.exports = __webpack_public_path__ + "assets/ee5ac1bd-d9cf-43b7-8e09-407b4c5d4e9e.f83ca742.svg";